import {ChangeDetectionStrategy, Component} from '@angular/core';
import {TranslatePipe} from "@ngx-translate/core";
import {IconComponent} from "../../../libs/icon/icon.component";

@Component({
  selector: 'acc-support-unavailable',
  imports: [
    IconComponent,
    TranslatePipe
  ],
  templateUrl: './support-unavailable.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './support-unavailable.component.css'
})
export class SupportUnavailableComponent {
}
